import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const other: AnswerPathTreeNode = {
  path: 'other',
  children: [{ path: 'otherInstructions', nodeId: NodeIds.otherInstructions }],
};
